import React from "react";
import CommunityOutreach from "components/community/CommunityOutreach";

const Community = () => {
  return (
    <>
      <div className="main-contents">
        <h1 className="heading-h5">Community Engagement</h1>
        <CommunityOutreach />
      </div>
    </>
  );
};

export default Community;
